import React from 'react'
import { FormattedMessage } from 'react-intl'
import Format from '../Format'

const PricePerNight = ({ value }) => (
  <FormattedMessage
    id='PricePerNight'
    defaultMessage='{price}/ngt'
    values={{
      price: <Format.Currency value={value} />,
    }}
  />
)

export default PricePerNight
